"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @deprecated use SaleTag from foundation/SaleTag
 * @optimized using svgo:^3.0.2
 */
export const Tag = createSVGIcon(
  <>
    <path
      d="M16 9.855V1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <path
      d="M22.104 3.154H9.684a1 1 0 0 0-.795.393l-1.684 2.21A1 1 0 0 0 7 6.363V28a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6.392a1 1 0 0 0-.237-.646l-1.896-2.239a1 1 0 0 0-.763-.353Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M19.107 9.855c0 1.67-1.38 3.045-3.107 3.045s-3.107-1.375-3.107-3.045S14.273 6.81 16 6.81s3.107 1.375 3.107 3.045Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  "TagIcon",
  { viewBox: "0 0 30 30", fill: "none", className: legacyIconCls() }
);
